import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { API } from "@/App";
import { Card } from "@/components/ui/card";
import { CheckCircle2, Loader2, Mail } from "lucide-react";

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [loading, setLoading] = useState(true);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (email) {
      fetch(`${API}/public/unsubscribe?email=${encodeURIComponent(email)}`)
        .then(r => r.json())
        .then(() => setDone(true))
        .catch(() => setDone(true))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [email]);

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center p-5">
      <Card className="max-w-md w-full rounded-2xl p-8 text-center space-y-4" data-testid="unsubscribe-page">
        {loading ? (
          <Loader2 className="w-8 h-8 animate-spin text-[#FF7A00] mx-auto" />
        ) : done ? (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto" />
            <h1 className="text-xl font-bold text-stone-900">You have been unsubscribed</h1>
            <p className="text-sm text-stone-500">You will no longer receive marketing emails from PlateMind. If this was a mistake, you can subscribe again from our website.</p>
          </>
        ) : (
          <>
            <Mail className="w-12 h-12 text-stone-400 mx-auto" />
            <h1 className="text-xl font-bold text-stone-900">Unsubscribe</h1>
            <p className="text-sm text-stone-500">No email address provided. If you followed an unsubscribe link and see this page, please contact support.</p>
          </>
        )}
        <a href="/" className="inline-block text-sm text-[#FF7A00] hover:underline mt-4">Back to PlateMind</a>
      </Card>
    </div>
  );
};

export default UnsubscribePage;
